var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _excluded = ["start"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _require = require('@babel/core'),
    transformSync = _require.transformSync;

var declare = require('@babel/helper-plugin-utils').declare;

var syntaxJsxPlugin = require('@babel/plugin-syntax-jsx');

var proposalObjectRestSpreadPlugin = require('@babel/plugin-proposal-object-rest-spread');

var BabelPluginExtractImportsAndExports = /*#__PURE__*/_createClass(function BabelPluginExtractImportsAndExports() {
  "use strict";

  _classCallCheck(this, BabelPluginExtractImportsAndExports);

  var nodes = [];
  this.state = {
    nodes: nodes
  };
  this.plugin = declare(function (api) {
    api.assertVersion(7);
    return {
      visitor: {
        ExportDefaultDeclaration: function ExportDefaultDeclaration(path) {
          var start = path.node.start;
          nodes.push({
            type: 'export',
            start: start,
            default: true
          });
        },
        ExportNamedDeclaration: function ExportNamedDeclaration(path) {
          var start = path.node.start;
          nodes.push({
            type: 'export',
            start: start
          });
        },
        ExportAllDeclaration: function ExportAllDeclaration(path) {
          var start = path.node.start;
          nodes.push({
            type: 'export',
            start: start
          });
        },
        ImportDeclaration: function ImportDeclaration(path) {
          var start = path.node.start; // Imports that are used in exports can end up as
          // ImportDeclarations with no start/end metadata,
          // these can be ignored

          if (start === undefined) {
            return;
          }

          nodes.push({
            type: 'import',
            start: start
          });
        }
      }
    };
  });
});

var partitionString = function partitionString(str, indices) {
  return indices.map(function (val, i) {
    return str.slice(val, indices[i + 1]);
  });
};

module.exports = function (value, vfile) {
  var instance = new BabelPluginExtractImportsAndExports();
  transformSync(value, {
    plugins: [syntaxJsxPlugin, proposalObjectRestSpreadPlugin, instance.plugin],
    filename: vfile.path,
    configFile: false,
    babelrc: false
  });
  var sortedNodes = instance.state.nodes.sort(function (a, b) {
    return a.start - b.start;
  });
  var nodeStarts = sortedNodes.map(function (n) {
    return n.start;
  });
  var values = partitionString(value, nodeStarts);
  var allNodes = sortedNodes.map(function (_ref, i) {
    var _ = _ref.start,
        node = _objectWithoutProperties(_ref, _excluded);

    var value = values[i];
    return _objectSpread(_objectSpread({}, node), {}, {
      value: value
    });
  }); // Group adjacent nodes of the same type so that they can be combined
  // into a single node later, this also ensures that order is preserved

  var currType = allNodes[0].type;
  var groupedNodes = allNodes.reduce(function (acc, curr) {
    // Default export nodes shouldn't be grouped with other exports
    // because they're handled specially by MDX
    if (curr.default) {
      currType = 'default';
      return [].concat(_toConsumableArray(acc), [[curr]]);
    }

    if (curr.type === currType) {
      var lastNodes = acc.pop();
      return [].concat(_toConsumableArray(acc), [[].concat(_toConsumableArray(lastNodes), [curr])]);
    }

    currType = curr.type;
    return [].concat(_toConsumableArray(acc), [[curr]]);
  }, [[]]); // Combine adjacent nodes into a single node

  return groupedNodes.filter(function (a) {
    return a.length;
  }).reduce(function (acc, curr) {
    var node = curr.reduce(function (acc, curr) {
      return _objectSpread(_objectSpread({}, acc), {}, {
        value: acc.value + curr.value
      });
    });
    return [].concat(_toConsumableArray(acc), [node]);
  }, []);
};